<button class="btn" (click)="scrollUp()">
  <i class="fa fa-arrow-up"></i>
</button>
